export enum LogCategory {
  PACKAGES = 'PACKAGES',
  BASKET = 'BASKET',
  FROM_PRICE_PACKAGES = 'FROM_PRICE_PACKAGES',
  TOURS = 'TOURS',
  FIT_SEARCH = 'FIT_SEARCH'
}
